import { useFormikContext } from 'formik';
import BaseErrorMessage from 'ui-new/ErrorMessage/ErrorMessage';

type ErrorMessageProps = { name: string };

const ErrorMessage = ({ name }: ErrorMessageProps) => {
    const { error, touched } = useFormikContext<any>().getFieldMeta(name);

    if (!error || !touched) {
        return null;
    }

    return <BaseErrorMessage>{error}</BaseErrorMessage>;
};

export default ErrorMessage;
